// ./01 - PROJETOS DEV/meu-controle-de-estoque/src/components/modals/EditPurchaseModal.jsx
import React, { useState, useEffect } from 'react';

const EditPurchaseModal = ({ isOpen, onClose, onSave, purchase }) => {
    const [formState, setFormState] = useState({
        description: '',
        purchaseDate: ''
    });
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen && purchase) {
            setFormState({
                description: purchase.description || '',
                purchaseDate: purchase.purchaseDate ? new Date(purchase.purchaseDate).toISOString().split('T')[0] : ''
            });
        }
    }, [isOpen, purchase]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSaving) return;
        setIsSaving(true);

        try {
            const updatedData = {
                description: formState.description,
                purchaseDate: formState.purchaseDate ? new Date(`${formState.purchaseDate}T12:00:00`) : null
            };
            
            // Atualiza a descrição dentro das parcelas para garantir consistência
            if (purchase.installments) {
                updatedData.installments = purchase.installments.map(inst => ({
                    ...inst,
                    description: formState.description
                }));
            }
            
            await onSave(purchase.id, updatedData);
            onClose();
        } catch (error) {
            console.error("Erro ao atualizar:", error);
            alert("Erro ao salvar alterações.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen || !purchase) return null;

    return (
        <div className="modal-overlay z-50 flex items-center justify-center fixed inset-0 bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md m-4">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Editar Compromisso</h2>
                <p className="text-sm text-gray-500 mb-6">Para manter a precisão matemática das baixas, apenas a descrição e a data podem ser alteradas. Se houver erro no valor total, exclua e registre novamente.</p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="form-label text-sm font-semibold text-gray-700">Nova Descrição</label>
                        <input name="description" value={formState.description} onChange={handleChange} type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div>
                        <label className="form-label text-sm font-semibold text-gray-700">Data da Compra</label>
                        <input name="purchaseDate" type="date" value={formState.purchaseDate} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4 border-t mt-4">
                        <button type="button" onClick={onClose} className="py-2 px-6 bg-gray-200 rounded-lg font-semibold text-gray-800 hover:bg-gray-300">Cancelar</button>
                        <button type="submit" disabled={isSaving} className="custom-button py-2 px-6 rounded-lg font-semibold">{isSaving ? 'Salvando...' : 'Salvar Alterações'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditPurchaseModal;